"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnReservator = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Icon_1 = require("../../../../../Icon");
require("./index.scss");
const className = 'flight-passenger-list-reservator';
const ColumnReservator = () => {
    return {
        id: 'reservator',
        Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/Reservator:Title', defaultMessage: 'Reservator' })),
        canSort: true,
        Cell: ({ row }) => {
            const { reservator } = row.original.reservation;
            const name = reservator.displayName;
            const icon = reservator.type == 'manager'
                ? 'malesia' : reservator.type == 'agent'
                ? 'agent' : reservator.type == 'customer'
                ? 'customer' : undefined;
            return (react_1.default.createElement("div", { className: className },
                react_1.default.createElement("span", { className: `${className}__icon` }, icon && (react_1.default.createElement(Icon_1.Icon, { name: icon }))),
                name && (react_1.default.createElement("span", { className: `${className}__name` }, name))));
        },
    };
};
exports.ColumnReservator = ColumnReservator;
//# sourceMappingURL=index.js.map